import create from 'zustand'

type BiometryStore = {
  callbackRoute: string
  biometryValidated: boolean
  biometryResult: string
}

export const useBiometryStore = create<BiometryStore>(() => ({
  callbackRoute: '',
  biometryValidated: false,
  biometryResult: '',
}))
